import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { Feature } from '@nirvana/shared/constants';
import {
  ConsoleRequest,
  DataProviderEntity,
  DataProviderType,
  GetCompaniesFeaturesPayload,
} from '../../../../utils/request';
import { ReconfigureAgentEndpointMethod } from '../../../types';
import { GetCompanyFeaturesResponse } from '../../../../utils/response';

export class ReconfigureAgentPanelDataProvider extends BaseWebComponentDataProvider {
  private featuresEndpoint = 'FeaturesManager';

  public async getFeaturesByCompanyIds(payload: GetCompaniesFeaturesPayload): Promise<Feature[]> {
    let response;

    try {
      response = await ConsoleRequest.createRequest<GetCompanyFeaturesResponse>({
        dataProviderType: DataProviderType.CORE,
        dataProviderEntity: DataProviderEntity.SYSTEM,
        endpoint: this.featuresEndpoint,
        method: ReconfigureAgentEndpointMethod.GET_FEATURES_BY_COMPANY_IDS,
        payload: payload,
      });
    } catch (e) {
      return [];
    }

    return response.features;
  }
}
